

export const getFromStorage = async (key: string): Promise<string | null> => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error('Error getting data from localStorage:', error);
    return null;
  }
};

export const saveToStorage = async (key: string, value: string): Promise<void> => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error('Error saving data to localStorage:', error);
  }
};

export const removeFromStorage = async (key: string): Promise<void> => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error removing data from localStorage:', error);
  }
};

export const clearStorage = async (): Promise<void> => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};
